import { RegionViewModel } from 'functions/app/geography/view/region'
import { MunicipalityViewModel } from 'functions/app/geography/view/municipality'
import type {
  MunicipalityFeatures,
  RegionFeatures,
} from '@schema/featureToggle'
import { RegionNavBar } from './RegionNavBar'
import { MunicipalityNavBar } from './MunicipalityNavBar'

export type RegionalNavBarProps =
  | { region: RegionViewModel; tab: RegionFeatures }
  | { municipality: MunicipalityViewModel; tab: MunicipalityFeatures }

export const RegionalNavBar = (props: RegionalNavBarProps) => {
  if ('municipality' in props) {
    return (
      <MunicipalityNavBar
        municipality={props.municipality}
        tab={props.tab}
      />
    )
  }

  return <RegionNavBar region={props.region} tab={props.tab} />
}
